{#if $isUserLoggedIn}
  <LazyComposeBox realm="home"/>
{:else}
  <HiddenFromSSR>
    <FreeTextLayout>
      <h1>Compose</h1>

      <p>Your local timeline will appear here when logged in.</p>
    </FreeTextLayout>
  </HiddenFromSSR>
{/if}
<script>
  import LazyComposeBox from '../_components/compose/LazyComposeBox.html'
  import FreeTextLayout from '../_components/FreeTextLayout.html'
  import { store } from '../_store/store.js'
  import HiddenFromSSR from '../_components/HiddenFromSSR.html'

  export default {
    store: () => store,
    components: {
      LazyComposeBox,
      FreeTextLayout,
      HiddenFromSSR
    }
  }
</script>
